<template>
  <el-dialog
    id="coachInfo"
    :visible.sync="showLocal"
    width="320px"
    center
  >
    <div class="content">
      <div class="profilePicture">
        <el-image
          style="width: 100px; height: 100px; border-radius: 50%;"
          :src="coach.profile_image"
          fit="cover"
        >
          <div
            slot="placeholder"
            v-loading="true"
            class="image-slot"
          >
            <!--Loading-->
          </div>
          <div
            slot="error"
            class="image-slot imageAlt"
          >
            <img
              src="@/assets/coach_avatar/default_profile.jpg"
              alt="profile"
              class="defaultProfile"
            />
            <!--<i class="el-icon-picture-outline"></i>-->
          </div>
        </el-image>
      </div>

      <div
        class="name"
        :style="{
          marginBottom: nonAcFlag ? '30px' : null,
        }"
      >
        {{ `${coach.first_name} ${coach.last_name}` }}
      </div>

      <div
        v-if="!nonAcFlag"
        class="pdfLinkBtn"
      >
        <el-button
          type="text"
          class="pdfLinkBtn"
          @click="openProfile"
        >
          {{ $t('leader.coach.viewFullProfile') }}
        </el-button>
      </div>

      <div
        v-if="coach.locations && coach.locations.length > 0"
        class="location"
      >
        <i class="infoIcon el-icon-location-outline"></i>
        <span>
          {{ coach.locations | displayLocations }}
        </span>
      </div>

      <div
        v-if="coach.languages && coach.languages.length > 0"
        class="language"
      >
        <i class="el-icon-info"></i>
        <span>
          {{ coach.languages | displayLanguage }}
        </span>
      </div>
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        round
        @click="clickSelectCoach"
      >
        {{ $t('leader.coach.selectAsMyCoach') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  filters: {
    displayLocations(value) {
      let label = '';
      if (value && Array.isArray(value) && value.length > 0) {
        label = value.map((el) => el.country.name).join(', ');
      }
      return label;
    },

    displayLanguage(value) {
      let label = '';
      if (value && Array.isArray(value) && value.length > 0) {
        label = value.map((el) => el.value).join(', ');
      }
      return label;
    },
  },

  mixins: [dialog],

  props: {
    coach: {
      type: Object,
      default: null,
    },
  },

  computed: {
    nonAcFlag() {
      let flag = false;
      if (this.coach && !this.coach.is_ac) {
        flag = true;
      }
      return flag;
    },
  },

  methods: {
    clickSelectCoach() {
      if (this.coach.meeting_status === 'completed') {
        this.selectCoach();
      } else {
        this.$msgbox({
          message: this.$t('leader.coach.confirmSelect', {
            coachName: `${this.coach.first_name} ${this.coach.last_name}`,
          }),
          showCancelButton: true,
          showClose: true,
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.goBack'),
          roundButton: true,
          customClass: 'warningNoMeeting',
          cancelButtonClass: 'el-button--info',
        }).then(() => {
          this.selectCoach();
        }).catch(() => {});
      }
    },

    selectCoach() {
      this.$emit('selectCoach', this.coach);
      this.showLocal = false;
    },

    openProfile() {
      window.open(this.coach.profile_url, '_blank');
    },
  },
};
</script>

<style lang="scss">
#coachInfo {
  .el-dialog {
    max-width: 95%;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 25px 25px 20px;
    }

    .el-dialog__footer {
      .dialog-footer {
        padding-bottom: 15px;
      }
    }
  }

  .content {
    > div {
      text-align: center;
    }

    .profilePicture {
      .image-slot {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        word-break: keep-all;
      }

      .imageAlt {
        width: 100%;
        height: 100%;

        i {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 35px;
          opacity: 0.7;
        }

        .defaultProfile {
          width: 100%;
          height: 100%;
        }
      }
    }

    .pdfLinkBtn {
      color: rgb(125, 125, 126);
      text-decoration: underline;
      margin-bottom: 10px;
    }

    .name {
      font-weight: bold;
      padding-top: 10px;
      font-size: 16px;
    }

    .language,
    .location {
      word-break: break-word;
      padding: 4px 0;

      .locationText,
      .languageText {
        padding: 0 4px;
      }
    }
  }
}

.warningNoMeeting {
  padding: 10px;

  .el-message-box__message {
    margin-bottom: 20px;
  }

  .el-message-box__btns {
    text-align: center;

    button {
      width: 48%;
    }
  }
}
</style>
